import { render, staticRenderFns } from "./emergencyRelationInfoDetail.vue?vue&type=template&id=6670c468"
import script from "./emergencyRelationInfoDetail.vue?vue&type=script&lang=js"
export * from "./emergencyRelationInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6670c468')) {
      api.createRecord('6670c468', component.options)
    } else {
      api.reload('6670c468', component.options)
    }
    module.hot.accept("./emergencyRelationInfoDetail.vue?vue&type=template&id=6670c468", function () {
      api.rerender('6670c468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/base/emergencyRelationInfoDetail.vue"
export default component.exports